var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4319_5269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66637 21.0043C7.21069 21.0043 5.81464 20.4512 4.78532 19.4666C3.756 18.482 3.17773 17.1467 3.17773 15.7543C3.17773 14.3619 3.756 13.0266 4.78532 12.042C5.81464 11.0574 7.21069 10.5043 8.66637 10.5043C9.01017 8.97267 10.0159 7.62669 11.4624 6.76246C12.1786 6.33454 12.9815 6.03777 13.8251 5.8891C14.6688 5.74042 15.5367 5.74275 16.3793 5.89596C17.222 6.04917 18.0228 6.35026 18.7362 6.78202C19.4496 7.21379 20.0615 7.76779 20.5369 8.41238C21.0124 9.05697 21.3421 9.77954 21.5073 10.5388C21.6725 11.2981 21.6699 12.0792 21.4997 12.8376H22.6664C23.7493 12.8376 24.788 13.2678 25.5537 14.0336C26.3195 14.7994 26.7497 15.838 26.7497 16.921C26.7497 18.0039 26.3195 19.0425 25.5537 19.8083C24.788 20.5741 23.7493 21.0043 22.6664 21.0043H21.4997",
    stroke: "#797978",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14V24.5",
    stroke: "#797978",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.5L14.5 14L18 17.5",
    stroke: "#797978",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4319_5269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.63483a883346ee1ea822ded495f50515.svg";
export { ForwardRef as ReactComponent };